/// <amd-module name="Pipeline/Analytics/PipelineStepsDurationCard/Stores/PipelineStepsDurationCardStore" />
import * as CommonResources from "Pipeline/Analytics/Common/Resources";
import { IPipelineReportBaseState, PipelineReportBaseStore } from "Pipeline/Analytics/Common/Stores/PipelineReportBaseStore";
import { IStageMetrics } from "Pipeline/Analytics/Common/Types";
import { PipelineStepsDurationCardActions } from "Pipeline/Analytics/PipelineStepsDurationCard/Actions/PipelineStepsDurationCardActions";
import { IPipelineStepDurationTrend, IStageStepsDurationData } from "Pipeline/Analytics/PipelineStepsDurationCard/Types";

export interface IPipelineStepsDurationCardState extends IPipelineReportBaseState<IPipelineStepDurationTrend[]> {
    stages: IStageMetrics[];
    topStepDurationData: IStageStepsDurationData;
    selectedStage: string;
}

export class PipelineStepsDurationCardStore extends PipelineReportBaseStore<
    PipelineStepsDurationCardActions,
    IPipelineStepsDurationCardState,
    IPipelineStepDurationTrend[]
> {
    constructor(public actions: PipelineStepsDurationCardActions) {
        super(actions);
        this.initializeListener();
    }

    public dispose(): void {
        this.actions.updateTopStepsDurationDataAction.removeListener(this.onUpdatetopStepDurationData);
        this.actions.selectStageAction.removeListener(this.setSelectedStage);
        super.dispose();
    }

    protected initializeListener(): void {
        this.actions.updateTopStepsDurationDataAction.addListener(this.onUpdatetopStepDurationData);
        this.actions.selectStageAction.addListener(this.setSelectedStage);
    }

    protected onUpdatetopStepDurationData = (data: IStageStepsDurationData) => {
        if (data) {
            this._state.errorText = undefined;
            this._state.topStepDurationData = data;
            if (data.stages && data.stages.length > 1) {
                const allStages = {
                    name: CommonResources.AllStageName,
                    fullName: CommonResources.AllStageName,
                    dataCount: data.stages.reduce((accumulator, stage) => {
                        return accumulator + stage.dataCount;
                    }, 0)
                } as IStageMetrics;
                this._state.stages = [allStages, ...data.stages];
                this._state.selectedStage = this._state.stages[0].name;
            }
            this.emitChanged();
        }
    };

    private setSelectedStage = (stage: IStageMetrics) => {
        if (stage) {
            this._state.selectedStage = stage.name;
            this.emitChanged();
        }
    };
}
